var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1474 14.9539H10.3958M3.87744 12.5399V14.8005C3.87744 14.8853 3.94611 14.9539 4.03082 14.9539H6.2915C6.33217 14.9539 6.37118 14.9378 6.39995 14.909L14.5052 6.80376C14.5651 6.74386 14.5651 6.64675 14.5052 6.58685L12.2445 4.32617C12.1846 4.26628 12.0875 4.26628 12.0276 4.32617L3.92236 12.4314C3.8936 12.4602 3.87744 12.4992 3.87744 12.5399Z",
    stroke: "url(#paint0_linear_43_595)",
    strokeWidth: 1.38037,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_43_595",
    x1: 3.87744,
    y1: 4.28125,
    x2: 18.0993,
    y2: 10.4639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.158668,
    stopColor: "#F76A4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.60652,
    stopColor: "#A24AE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891362,
    stopColor: "#4859F3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.e3509929279d364fe596f84fb1698011.svg";
export { ForwardRef as ReactComponent };